<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Réaliser son activité selon les cadres réglementaires établis" index-progression-courante="3"
                   index-progression-secondaire="11"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="adapteraction"/>
    <footer-applis ecran-precedent="apprendreseformer" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'realiseractivite',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'identifie les normes associées aux activités d’un métier donné'
      }, {
        niveau: 2,
        valeur: 'J\'applique les mesures règlementaires dans un environnement donné'
      }, {
        niveau: 3,
        valeur: 'J\'explicite le sens et la valeur des règlementations dans un environnement de travail'
      }, {
        niveau: 4,
        valeur: 'J\'analyse les enjeux liés au respect des normes et des règlements'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.realiseractivite = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('adapteraction');
    }
  }
}
</script>
